export default "__VITE_ASSET__dk2yPEOh__"